import React from 'react';

import { Button, Modal } from '@/components';
import { useTranslation } from 'react-i18next';
import LottieAnimation from '@/components/lottie-animation/LottieAnimation';
import animationData from '@/utils/lottie/SuccessAnimation.json';
import styles from './DraftSuccessModal.module.css';

interface DraftSuccessModalProps {
  onCancel: () => void;
}

function DraftSuccessModal({ onCancel }: DraftSuccessModalProps) {
  const { t } = useTranslation();

  return (
    <Modal closeButton={false} modalStyles={{ maxWidth: '480px' }}>
      <div className={styles.welcomeModal}>
        <div className={styles.lottie}>
          <LottieAnimation
            animationData={animationData}
            styles={{
              width: '120px',
              height: '120px'
            }}
          />
        </div>
        <h2 className={styles.welcomeModalTitle}>{t('draft.success')}</h2>
        {/* <h2 className={styles.welcomeModalDescription}>
          {type === 'BEAT_FINISHED' && t('screenshot.modal.beatDescription')}
        </h2> */}

        <div className={styles.welcomeModalButton}>
          <Button theme="cta" onClick={onCancel}>
            {t('actions.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DraftSuccessModal;
